import { render, staticRenderFns } from "./Material.vue?vue&type=template&id=1e0b3c3c"
var script = {}
import style0 from "./Material.vue?vue&type=style&index=0&id=1e0b3c3c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports